import Typography from "@mui/material/Typography";

import { FC } from "react";

interface FieldTitleProps {
  title: string;
  align?: "left" | "right" | "center";
}

const FieldTitle: FC<FieldTitleProps> = ({ title, align }) => {
  return (
    <Typography
      sx={{
        display: "flex",
        justifyContent: align ? align : "left",
        padding: "10px 0",
        fontSize: "14px",
      }}
    >
      {title}
    </Typography>
  );
};

export default FieldTitle;
